import React from 'react';
import { Modal } from 'react-bootstrap';
import Filter from '../../pages/DashBoard/filter';

const MobileFilterModal = ({
    selectedCardData,
    getMatchingProfilesCon,
    formResetFlag,
    getMatchingProfiles,
    filterModal,
    setFIlterModal
}) => {

    const handleClose = () =>{
        setFIlterModal(false)
    }

  return (
    
    <Modal
        className='modal'
        show={filterModal}
        size="xl"
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body className='table-scrollY'>
        <Filter
            formResetFlag={formResetFlag}
            selectedCardData={selectedCardData}
            getMatchingProfilesCon={getMatchingProfilesCon}
            getMatchingProfiles={getMatchingProfiles}
            setFIlterModal={setFIlterModal}
        />
        </Modal.Body>
      </Modal>

  )
}

export default MobileFilterModal